(function(){
  'use strict';
  var THRESHOLD = (window.BV_FREE_SHIP || 500) * 100;

  function money(cents){
    // 30 Eyl: binlik ayırıcı (1.428,00 ₺) — bp-para.liquid ile aynı biçim
    var p = (Math.abs(cents) / 100).toFixed(2).split('.');
    return (cents < 0 ? '−' : '') + p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + p[1] + ' ₺';
  }
  function $(s, root){ return (root || document).querySelector(s); }
  function $$(s, root){ return (root || document).querySelectorAll(s); }

  var overlay, drawer, itemsEl, emptyEl, footer, subEl, countEl, shipEl, shipText, shipBar, crossEl, crossList;
  var lastCrossVendor = null;

  function open(){
    if (!drawer) return;
    drawer.classList.remove('translate-x-full');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.classList.remove('invisible', 'opacity-0');
    document.body.style.overflow = 'hidden';
  }
  function close(){
    if (!drawer) return;
    drawer.classList.add('translate-x-full');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.classList.add('opacity-0');
    setTimeout(function(){ overlay.classList.add('invisible'); }, 300);
    document.body.style.overflow = '';
  }

  function render(cart){
    countEl.textContent = cart.item_count;
    $$('[data-header-cart-count]').forEach(function(el){ el.textContent = cart.item_count; el.classList.toggle('hidden', cart.item_count === 0); });

    if (cart.item_count === 0){
      emptyEl.classList.remove('hidden');
      itemsEl.innerHTML = '';
      footer.classList.add('hidden');
      shipEl.classList.add('hidden');
      return;
    }
    emptyEl.classList.add('hidden');
    footer.classList.remove('hidden');

    if (THRESHOLD > 0){
      shipEl.classList.remove('hidden');
      var remaining = Math.max(0, THRESHOLD - cart.total_price);
      var pct = Math.min(100, (cart.total_price / THRESHOLD) * 100);
      if (remaining === 0){
        shipText.innerHTML = '<span class="text-primary font-bold">Ücretsiz kargo kazandınız!</span>';
      } else {
        shipText.innerHTML = '<strong>' + money(remaining) + '</strong> daha ekle, <strong class="text-primary">ücretsiz kargo</strong> kazan';
      }
      shipBar.style.transform = 'scaleX(' + (pct / 100) + ')';
    }

    var tpl = $('#bv-drawer-item-tpl');
    itemsEl.innerHTML = '';
    cart.items.forEach(function(item){
      var node = tpl.content.cloneNode(true);
      var row = node.querySelector('[data-key]');
      row.setAttribute('data-key', item.key);
      var imgLink = row.querySelector('.bv-item-img');
      imgLink.setAttribute('href', item.url);
      var img = imgLink.querySelector('img');
      if (item.image) img.setAttribute('src', item.image.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original)\./, '_150x.'));
      img.setAttribute('alt', item.title);
      row.querySelector('.bv-item-title').setAttribute('href', item.url);
      row.querySelector('.bv-item-title').textContent = item.product_title || item.title;
      row.querySelector('.bv-item-vendor').textContent = item.vendor || '';
      row.querySelector('.bv-item-qty').textContent = item.quantity;
      row.querySelector('.bv-item-price').textContent = money(item.final_line_price);

      row.querySelector('.bv-qty-inc').addEventListener('click', function(){ quickUpdate(item.key, item.quantity + 1, row); });
      row.querySelector('.bv-qty-dec').addEventListener('click', function(){ quickUpdate(item.key, Math.max(0, item.quantity - 1), row); });
      row.querySelector('.bv-item-remove').addEventListener('click', function(){ quickRemove(item.key, row); });

      itemsEl.appendChild(node);
      addDrawerSwipe(row, item.key);
    });
    subEl.textContent = money(cart.total_price);
    if (cart.item_count > 0) {
      var cartPids = cart.items.map(function(i){ return i.product_id; });
      fetchCrossSell(cart.items[0].vendor, cartPids);
    } else if (crossEl) {
      crossEl.classList.add('hidden');
    }
  }

  function fetchCrossSell(vendor, cartPids) {
    if (!crossEl || !crossList) return;
    if (lastCrossVendor === vendor) return;
    lastCrossVendor = vendor;
    var q = vendor || 'vitamin';
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[fields]=title,price,image,handle,vendor', {credentials:'same-origin'})
      .then(function(r){ return r.json(); })
      .then(function(data){
        var prods = (data.resources && data.resources.results && data.resources.results.products) || [];
        prods = prods.filter(function(p){ return cartPids.indexOf(p.id) === -1; });
        if (prods.length === 0){ crossEl.classList.add('hidden'); return; }
        crossList.innerHTML = '';
        prods.slice(0, 5).forEach(function(p){
          var price = parseFloat(p.price) || 0;
          var priceStr = price > 0 ? money(Math.round(price * 100)) : '';
          var imgHtml = p.image
            ? '<img src="' + p.image + '" alt="" class="w-full h-16 object-contain bg-surface-container-lowest p-1">'
            : '<div class="w-full h-16"></div>';
          var card = document.createElement('a');
          card.href = p.url || ('/products/' + p.handle);
          card.className = 'snap-start shrink-0 w-24 flex flex-col rounded-xl overflow-hidden border border-outline-variant/20 bg-surface hover:border-primary/40 transition-colors';
          card.innerHTML = imgHtml + '<div class="p-1.5"><p class="text-[9px] font-semibold text-on-surface line-clamp-2 leading-tight mb-0.5">' + p.title + '</p><p class="text-[10px] font-extrabold text-primary">' + priceStr + '</p></div>';
          crossList.appendChild(card);
        });
        crossEl.classList.remove('hidden');
      })
      .catch(function(){ crossEl.classList.add('hidden'); });
  }

  function updateShipBar(cart){
    if(THRESHOLD > 0 && shipEl){
      var rem = Math.max(0, THRESHOLD - cart.total_price);
      var pct = Math.min(100, (cart.total_price / THRESHOLD) * 100);
      if(rem === 0) shipText.innerHTML = '<span class="text-primary font-bold">Ücretsiz kargo kazandınız!</span>';
      else shipText.innerHTML = '<strong>'+money(rem)+'</strong> daha ekle, <strong class="text-primary">ücretsiz kargo</strong> kazan';
      shipBar.style.transform = 'scaleX(' + (pct / 100) + ')';
    }
  }

  function syncUI(cart){
    subEl.textContent = money(cart.total_price);
    countEl.textContent = cart.item_count;
    $$('[data-header-cart-count]').forEach(function(el){ el.textContent = cart.item_count; el.classList.toggle('hidden', cart.item_count === 0); });
    updateShipBar(cart);
    if(cart.item_count === 0){
      emptyEl.classList.remove('hidden');
      footer.classList.add('hidden');
      shipEl.classList.add('hidden');
      itemsEl.innerHTML = '';
    }
  }

  // OPTIMISTIC: instantly hide row + update price, then sync API
  function addDrawerSwipe(row, key){
    var DEL_W = 76, startX, startY, currentX = 0, swiping = false, open = false;
    var inner = row.querySelector('.bv-swipe-inner');
    var bg = row.querySelector('.bv-swipe-bg');
    if(!inner || !bg) return;

    bg.addEventListener('click', function(){ quickRemove(key, row); });

    function snapTo(x, animate){
      if(animate) inner.style.transition = 'transform .25s cubic-bezier(.25,.46,.45,.94)';
      inner.style.transform = 'translateX(' + x + 'px)';
      if(animate) setTimeout(function(){ inner.style.transition = ''; }, 260);
    }

    row.addEventListener('touchstart', function(e){
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      currentX = open ? -DEL_W : 0;
      swiping = false;
      inner.style.transition = 'none';
    }, {passive:true});

    row.addEventListener('touchmove', function(e){
      if(!startX) return;
      var dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;
      if(!swiping && Math.abs(dy) > Math.abs(dx)){ startX = null; return; }
      swiping = true;
      var base = open ? -DEL_W : 0;
      currentX = Math.min(0, Math.max(base + dx, -DEL_W - 8));
      inner.style.transform = 'translateX(' + currentX + 'px)';
      if(Math.abs(dx) > 5) e.preventDefault();
    }, {passive:false});

    row.addEventListener('touchend', function(){
      if(!swiping){ startX = null; return; }
      var moved = Math.abs(currentX);
      if(!open && moved >= DEL_W * 0.4){ open = true; snapTo(-DEL_W, true); }
      else if(open && moved < DEL_W * 0.6){ open = false; snapTo(0, true); }
      else if(!open){ snapTo(0, true); }
      else { snapTo(-DEL_W, true); }
      startX = null; swiping = false;
    }, {passive:true});

    document.addEventListener('touchstart', function(e){
      if(open && !row.contains(e.target)){ open = false; snapTo(0, true); }
    }, {passive:true});
  }

  function quickRemove(key, row){
    // Get item price from row to subtract optimistically
    var priceText = row.querySelector('.bv-item-price').textContent;
    var priceVal = parseFloat(priceText.replace(/[^\d,]/g,'').replace(',','.')) * 100;

    var h = row.offsetHeight;
    row.style.height = h + 'px';
    row.style.overflow = 'hidden';
    row.style.transition = 'height .15s ease, opacity .1s ease, margin .15s ease';
    requestAnimationFrame(function(){
      row.style.height = '0';
      row.style.opacity = '0';
      row.style.marginBottom = '0';
    });
    setTimeout(function(){ row.style.display = 'none'; }, 160);

    // Update count + price optimistically
    var c = Math.max(0, parseInt(countEl.textContent) - 1);
    countEl.textContent = c;
    $$('[data-header-cart-count]').forEach(function(el){ el.textContent = c; });
    var currentTotal = parseFloat(subEl.textContent.replace(/[^\d,]/g,'').replace(',','.')) * 100;
    var newTotal = Math.max(0, currentTotal - priceVal);
    subEl.textContent = money(newTotal);

    // API call in background
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json','Accept':'application/json'},
      credentials: 'same-origin',
      body: JSON.stringify({id: key, quantity: 0})
    }).then(function(r){ return r.json(); }).then(syncUI);
  }

  // OPTIMISTIC: instantly update qty display
  function quickUpdate(key, quantity, row){
    if(quantity <= 0){ quickRemove(key, row); return; }
    var qtyEl = row.querySelector('.bv-item-qty');
    qtyEl.textContent = quantity;
    qtyEl.style.transform = 'scale(1.3)';
    setTimeout(function(){ qtyEl.style.transform = 'scale(1)'; }, 150);
    qtyEl.style.transition = 'transform .15s';
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json','Accept':'application/json'},
      credentials: 'same-origin',
      body: JSON.stringify({id: key, quantity: quantity})
    }).then(function(r){ return r.json(); }).then(function(cart){
      syncUI(cart);
      var item = cart.items.find(function(i){ return i.key === key; });
      if(item) row.querySelector('.bv-item-price').textContent = money(item.final_line_price);
    });
  }

  function fetchCart(){
    return fetch('/cart.js', {headers:{'Accept':'application/json'}, credentials:'same-origin'})
      .then(function(r){ return r.json(); });
  }

  function addToCart(variantId, quantity, properties){
    var item = {id: variantId, quantity: quantity || 1};
    // 2 Kas: "Bitmeden hatırlat" gibi gizli satır özellikleri
    if (properties) item.properties = properties;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json','Accept':'application/json'},
      credentials: 'same-origin',
      body: JSON.stringify({items: [item]})
    }).then(function(r){
      if(!r.ok) return r.json().then(function(e){ throw e; });
      return r.json();
    }).then(function(){
      return fetchCart();
    }).then(function(cart){
      render(cart);
      return cart;
    }).catch(function(err){
      alert((err && err.description) || 'Ürün sepete eklenemedi.');
    });
  }

  window.CeptEczaCart = {
    open: function(){ return fetchCart().then(function(c){ render(c); open(); }); },
    // 2 Kas: add() sepeti zaten çekip çizdiği için ekleme sonrası yeniden istek atmadan açar
    show: open,
    close: close,
    add: addToCart,
    refresh: function(){ return fetchCart().then(render); }
  };

  document.addEventListener('DOMContentLoaded', function(){
    overlay = $('#bv-drawer-overlay');
    drawer = $('#bv-drawer');
    itemsEl = $('#bv-drawer-items');
    emptyEl = $('#bv-drawer-empty');
    footer = $('#bv-drawer-footer');
    subEl = $('#bv-drawer-subtotal');
    countEl = $('#bv-drawer-count');
    shipEl = $('#bv-drawer-ship');
    shipText = $('#bv-drawer-ship-text');
    shipBar = $('#bv-drawer-ship-bar');
    crossEl = $('#bv-cross');
    crossList = $('#bv-cross-list');
    if (!drawer) return;

    $('#bv-drawer-close').addEventListener('click', close);
    overlay.addEventListener('click', close);
    $$('.bv-drawer-close-btn').forEach(function(b){ b.addEventListener('click', close); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') close(); });

    // Header cart icon opens drawer
    $$('a[href*="/cart"]:not([href*="/cart/add"]):not([href*="/cart/change"]):not([data-no-drawer])').forEach(function(a){
      if(a.getAttribute('href') === '/cart' || a.getAttribute('href') === '{{ routes.cart_url }}'){
        a.addEventListener('click', function(e){ e.preventDefault(); window.CeptEczaCart.open(); });
      }
    });

    // Fly-to-cart animation
    function flyToCart(btn){
      var cartIcon = document.querySelector('[data-header-cart-count]');
      if(!cartIcon) return;
      var from = btn.getBoundingClientRect();
      var to = cartIcon.getBoundingClientRect();
      var dot = document.createElement('div');
      dot.className = 'bv-fly-dot';
      dot.style.left = (from.left + from.width/2 - 9) + 'px';
      dot.style.top = (from.top + window.scrollY + from.height/2 - 9) + 'px';
      dot.style.setProperty('--tx', (to.left - from.left) + 'px');
      dot.style.setProperty('--ty', (to.top - from.top - window.scrollY) + 'px');
      document.body.appendChild(dot);
      dot.addEventListener('animationend', function(){ dot.remove(); });
    }

    // Variant picker sheet
    var vsSheet = document.getElementById('bv-variant-sheet');
    var vsPanel = document.getElementById('bv-variant-panel');
    var vsBackdrop = document.getElementById('bv-variant-backdrop');
    var vsClose = document.getElementById('bv-vs-close');
    var vsOptions = document.getElementById('bv-vs-options');
    var vsAddBtn = document.getElementById('bv-vs-add');
    var vsImg = document.getElementById('bv-vs-img');
    var vsName = document.getElementById('bv-vs-name');
    var vsPrice = document.getElementById('bv-vs-price');
    var selectedVid = null;

    function closeVS(){
      if(!vsSheet) return;
      vsPanel.style.transform = 'translateY(100%)';
      setTimeout(function(){ vsSheet.classList.remove('bv-vs-open'); }, 300);
    }
    function openVS(handle, fallbackVid){
      if(!vsSheet) return;
      selectedVid = null;
      if(vsAddBtn) vsAddBtn.disabled = true;
      if(vsOptions) vsOptions.innerHTML = '<div class="py-4 text-center"><span class="material-symbols-outlined text-primary" style="animation:spin 1s linear infinite;display:inline-block">progress_activity</span></div>';
      vsSheet.classList.add('bv-vs-open');
      setTimeout(function(){ vsPanel.style.transform = 'translateY(0)'; }, 10);
      fetch('/products/' + handle + '.js', {credentials:'same-origin'})
        .then(function(r){ return r.json(); })
        .then(function(p){
          if(vsImg){ var _fi=p.featured_image; vsImg.src = _fi ? (typeof _fi==='object'?(_fi.src||''):_fi) : ''; }
          if(vsName) vsName.textContent = p.title;
          if(vsPrice) vsPrice.textContent = (p.price/100).toFixed(2).replace('.',',') + ' ₺';
          vsOptions.innerHTML = '';
          p.variants.forEach(function(v){
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.textContent = v.title === 'Default Title' ? 'Standart' : v.title;
            btn.disabled = !v.available;
            btn.className = 'px-4 py-2.5 rounded-lg border-2 text-sm font-semibold transition-colors '
              + (v.available ? 'border-outline-variant/50 text-on-surface hover:border-primary' : 'border-outline-variant/20 text-on-surface/30 cursor-not-allowed');
            btn.setAttribute('data-vid', v.id);
            btn.addEventListener('click', function(){
              vsOptions.querySelectorAll('button').forEach(function(b){ b.classList.remove('border-primary','bg-primary/5','text-primary'); b.classList.add('border-outline-variant/50'); });
              btn.classList.add('border-primary','bg-primary/5','text-primary');
              btn.classList.remove('border-outline-variant/50');
              selectedVid = v.id;
              if(vsAddBtn) vsAddBtn.disabled = false;
            });
            vsOptions.appendChild(btn);
          });
        }).catch(function(){
          vsOptions.innerHTML = '<p class="text-sm text-error">Yüklenemedi, tekrar deneyin.</p>';
        });
    }

    if(vsBackdrop) vsBackdrop.addEventListener('click', closeVS);
    if(vsClose) vsClose.addEventListener('click', closeVS);
    if(vsAddBtn) vsAddBtn.addEventListener('click', function(){
      if(!selectedVid) return;
      vsAddBtn.disabled = true;
      addToCart(selectedVid, 1).then(function(cart){
        if(cart){ closeVS(); open(); }
      }).finally(function(){ vsAddBtn.disabled = false; });
    });

    // Product cards: add-to-cart with fly animation + variant sheet
    document.addEventListener('click', function(e){
      var btn = e.target.closest('[data-add-to-cart]');
      if(!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var vid = btn.getAttribute('data-variant-id');
      var handle = btn.getAttribute('data-handle');
      var varCount = parseInt(btn.getAttribute('data-variants-count') || '1', 10);
      if(!vid) return;
      // Multi-variant: show picker sheet
      if(varCount > 1 && handle && vsSheet){
        openVS(handle, vid);
        return;
      }
      btn.disabled = true;
      btn.classList.add('active');
      flyToCart(btn);
      addToCart(vid, 1).then(function(cart){ if(cart) open(); }).finally(function(){
        setTimeout(function(){ btn.disabled = false; btn.classList.remove('active'); }, 1500);
      });
    });

    // Intercept product form submits
    document.addEventListener('submit', function(e){
      var form = e.target;
      if(form.matches && form.matches('form[action="/cart/add"], form[action*="/cart/add"]')){
        e.preventDefault();
        var fd = new FormData(form);
        var variantId = fd.get('id');
        var quantity = parseInt(fd.get('quantity') || '1', 10);
        if(!variantId) return;
        var submitBtn = form.querySelector('[type="submit"]');
        if(submitBtn) submitBtn.disabled = true;
        addToCart(variantId, quantity).finally(function(){
          if(submitBtn) submitBtn.disabled = false;
        });
      }
    });

    fetchCart().then(render).catch(function(){});
  });
})();
